export default function FormatDate({date}){
    const format = new Date(date).toLocaleString('pt-BR',{
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute:'2-digit',
        second:'2-digit'
    })

    return(
        <div>
            <span>{format}</span>
        </div>
    )
} 